export const headerCells = [
  {
    id: "id",
    numeric: true,
    disablePadding: true,
    label: "ID"
  },
  {
    id: "name",
    numeric: false,
    disablePadding: true,
    label: "Name"
  },
  {
    id: "active",
    numeric: false,
    disablePadding: true,
    label: "Active"
  }
];

export default headerCells;
